module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAF3RSTlMAREv8+ntVU4JZf1/ahlB4R/bW0rU55vnlTp4AAAC6SURBVEjH7dW7DsMgDIVhN5Ab0CZpkvr937TZjlRkDEOlDP5X+FYfsizrts2752IuRcnGD+tJ+s28r49C6/UjCdjx4Scq9PQHO+GNuRt9KNlXxyxjGnwoWCpjGlyQrYahc6tj6Nzq+NI9/TT5kXQMndlKDA1bj2mGhtUxdG51DA1bj6FhqzH0QhRgKzF08AM1YmgH24rpPKkdI8O3xI4XDS/i3U689eXF6DdxMSJXJC9d0miKZFnWH/sCoagaIDoIKIAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_person_msg.png
// module id = xFZd
// module chunks = 21